<div class="lk-wrap">
  <div class="lk-card">
    <div class="lk-badge" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <rect x="4" y="11" width="16" height="9.5" rx="2.2"></rect>
        <path d="M8 11V7.5a4 4 0 0 1 8 0V11"></path>
        <circle cx="12" cy="15.4" r="1.25"></circle>
        <path d="M12 16.65V18"></path>
      </svg>
    </div>

    <ng-container *ngIf="loading; else loaded">
      <h1 class="lk-title">Checking your access…</h1>
      <p class="lk-sub">One moment.</p>
    </ng-container>

    <ng-template #loaded>
      <h1 class="lk-title">Access locked</h1>
      <p class="lk-sub">Your account is currently locked.</p>

      <div class="lk-blocks" *ngIf="status?.blocks?.length; else noDetail">
        <div class="lk-block" *ngFor="let block of status.blocks">
          <span class="lk-block-title">{{ block.title }}</span>
          <p class="lk-block-msg">{{ block.message }}</p>

          <ul class="lk-cases" *ngIf="block.items?.length">
            <li *ngFor="let item of block.items">
              <button type="button" class="lk-case" (click)="openRequest(item.requestId)">
                <span class="lk-case-label">{{ item.label }}</span>
                <svg class="lk-case-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 6l6 6-6 6"></path>
                </svg>
              </button>
            </li>
          </ul>

          <p class="lk-hint" *ngIf="block.items?.length">
            Open a case to review it — you can’t access anything else until they’re approved.
          </p>
        </div>
      </div>

      <ng-template #noDetail>
        <div class="lk-note">Please contact your manager to have your access restored.</div>
      </ng-template>

      <div class="lk-actions">
        <button type="button" class="lk-btn lk-btn-primary" (click)="recheck()" [disabled]="checking">
          {{ checking ? 'Checking…' : 'Re-check access' }}
        </button>
        <button type="button" class="lk-btn lk-btn-ghost" (click)="logout()">Log out</button>
      </div>
    </ng-template>
  </div>
</div>
